import React from 'react';

const TableComponent = ({ columns, data, className: tableClassName }) => { // Adiciona tableClassName para a classe da tabela principal
  return (
    <table className={`table ${tableClassName || ''}`}> {/* Usa a classe passada ou uma string vazia */}
      <thead>
        <tr>
          {columns.map((column) => (
            // Aplica a className da definição da coluna ao <th>
            <th key={column.key} className={column.className || ''}> 
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row.id}>
            {columns.map((column) => (
              // Aplica a className da definição da coluna ao <td>
              <td key={column.key} className={column.className || ''}>
                {column.render ? column.render(row) : row[column.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableComponent;
